import {
  Grid,
  CurrencyInput,
  Typography,
  TextFielDecimalNumbers,
} from "../../../../components/";
import {
  formatPrecisaoFloat,
  formatPrice,
  unformatPrice,
} from "../../../../utils";
import {
  calculoDesconto,
  formatProdutosTotalizadores,
  totalPedido,
} from "../addPedidos";

const ResumoTotal = ({
  abaValue,
  pedido,
  setPedido,
  listaPedidosProdutos,
  setListaPedidosProdutos,
  pedidoEntity,
}) => {
  const handleInputChangeDespesas = (event) => {
    const name = "despesas";
    const valor = unformatPrice(event.target.value);
    const totalNota = totalPedido(listaPedidosProdutos, name);
    const listItensDespesas = formatProdutosTotalizadores(
      name,
      listaPedidosProdutos,
      valor,
      totalNota
    );
    setListaPedidosProdutos(listItensDespesas);
    pedidoEntity.setChangeItens(listItensDespesas);
    setPedido({ ...pedidoEntity });
  };

  const handleInputDesconto = (event) => {
    if (listaPedidosProdutos?.length) {
      const name = "desconto";
      const valor = unformatPrice(event.target.value);
      if (
        parseFloat(pedido[event.target.name].toFixed(2)) !==
        formatPrecisaoFloat(parseFloat(valor))
      ) {
        const totalNota = totalPedido(listaPedidosProdutos, name);
        const pedidoTemp = {
          ...pedido,
          [event.target.name]: valor || 0,
        };
        if (event.target.name === "desconto") {
          pedidoTemp.descontoPorcentagem = calculoDesconto(
            listaPedidosProdutos,
            pedidoTemp,
            false
          );
          const listItensDesconto = formatProdutosTotalizadores(
            name,
            listaPedidosProdutos,
            valor,
            totalNota
          );
          setListaPedidosProdutos(listItensDesconto);
          pedidoEntity.setChangeItens(listItensDesconto);
          setPedido({ ...pedidoEntity });
        } else {
          pedidoTemp.desconto = calculoDesconto(
            listaPedidosProdutos,
            pedidoTemp
          );
          const listItensDesconto = formatProdutosTotalizadores(
            name,
            listaPedidosProdutos,
            pedidoTemp?.desconto,
            totalNota
          );
          setListaPedidosProdutos(listItensDesconto);
          pedidoEntity.setChangeItens(listItensDesconto);
          setPedido({ ...pedidoEntity });
        }
      }
    }
  };

  const nextFocusInput = (event) => {
    if (event.keyCode === 13) {
      const { form } = event.target;
      const arrayInput = Array.from(form.elements).filter(
        (element) => element.tagName == "INPUT"
      );
      const index = arrayInput.indexOf(event.target);
      let element = arrayInput[index + 1];
      if (element?.disabled) {
        element = arrayInput[index + 2];
      }
      if (element) {
        element.focus();
      } else {
        arrayInput[index].blur();
      }
      event.preventDefault();
    }
  };

  return (
    <form>
      <Grid container spacing={2} justifyContent="center" className="mx-3">
        <Grid
          item
          xs={9}
          md={2}
          className="d-flex align-items-center justify-content-end"
        >
          <span className="me-2">Subtotal:</span>
          <span className="badge bg-primary bg-gradient bg-gradient text-wrap p-2">
            <Typography color="white" style={{ fontWeight: 700 }}>
              {formatPrice(pedidoEntity.totalItens || 0)}
            </Typography>
          </span>
        </Grid>
        <Grid
          item
          xs={5}
          className="d-flex align-items-center justify-content-end"
        >
          <span className="me-2">Desconto:</span>
          <TextFielDecimalNumbers
            id="descontoPorcentagem"
            name="descontoPorcentagem"
            disabled={
              pedido.status === "CANCELADO" ||
              pedido.status === "BAIXADO" ||
              abaValue !== 0 ||
              pedido?.descontoItem
            }
            variant="outlined"
            margin="none"
            size="small"
            value={pedido?.descontoPorcentagem ?? 0}
            onBlur={handleInputDesconto}
            onKeyDown={nextFocusInput}
          />
          <CurrencyInput
            id="desconto"
            name="desconto"
            disabled={
              pedido.status === "CANCELADO" ||
              pedido.status === "BAIXADO" ||
              abaValue !== 0 ||
              pedido?.descontoItem
            }
            className="px-1"
            variant="outlined"
            margin="none"
            size="small"
            value={pedido?.desconto ?? 0}
            onBlur={handleInputDesconto}
            onKeyDown={nextFocusInput}
          />
        </Grid>
        <Grid
          item
          xs={3}
          className="d-flex align-items-center justify-content-end"
        >
          <span className="me-2">Despesas:</span>
          <CurrencyInput
            id="despesas"
            name="despesas"
            disabled={
              pedido.status === "CANCELADO" ||
              pedido.status === "BAIXADO" ||
              abaValue !== 0 ||
              pedido?.despesasItem
            }
            variant="outlined"
            margin="none"
            value={pedido?.despesas ?? 0}
            size="small"
            onBlur={handleInputChangeDespesas}
            onKeyDown={nextFocusInput}
          />
        </Grid>
        <Grid
          item
          xs={2}
          className="d-flex align-items-center justify-content-end"
        >
          <span className="me-2">Total:</span>
          <span className="badge bg-primary bg-gradient bg-gradient text-wrap p-2">
            <Typography color="white" style={{ fontWeight: 700 }}>
              {formatPrice(pedidoEntity?.totalPedido || 0)}
            </Typography>
          </span>
        </Grid>
      </Grid>
    </form>
  );
};
export default ResumoTotal;
